import { render, staticRenderFns } from "./decretos.vue?vue&type=template&id=0e4221cc&scoped=true"
import script from "./decretos.vue?vue&type=script&lang=js"
export * from "./decretos.vue?vue&type=script&lang=js"
import style0 from "./decretos.vue?vue&type=style&index=0&id=0e4221cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4221cc",
  null
  
)

export default component.exports